import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetOrderListRequest,
  failGetOrderList,
  setGetOrderList,
  setGetOrderListFromApi,
  updateGetOrderList,
  updateGetOrderListFromApi,
} from './get-order-list.actions';

/**
 * Service to handle async GetOrderList actions
 */
@Injectable()
export class GetOrderListEffect {
  /**
   * Set the state with the reply content, dispatch failGetOrderList if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetOrderListFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetOrderList({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetOrderList({ error, requestId: action.requestId })),
        cancelGetOrderListRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetOrderList if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetOrderListFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetOrderList({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetOrderList({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
